import { ColumnState } from 'ag-grid-community';
import { TableV3Sort } from 'common/table/types/TableV3';

export const getSortedColumn = <K>(
  columnState: ColumnState[]
): TableV3Sort<K> | null => {
  // Match on the sort direction being present, not on `!== null`. AG Grid types
  // ColumnState.sort as optional, so an unsorted column can carry `undefined`
  // rather than `null` — most notably the selection column AG Grid inserts ahead
  // of the real ones on tables with row selection. `!== null` treats that as a
  // match, so `find` stops on the selection column, `direction` comes back
  // undefined, and the sorted column is never reached.
  const findSortedColumn = columnState.find(
    (column) => column.sort === 'asc' || column.sort === 'desc'
  );
  const columnId = findSortedColumn?.colId;
  const direction = findSortedColumn?.sort;

  if (!columnId || !direction) {
    return null;
  }

  return {
    field: columnId as K,
    direction: direction as 'asc' | 'desc'
  };
};
